// 兼容低版本
import 'babel-polyfill'
import promise from 'es6-promise'
promise.polyfill()


import { createApp } from 'vue';
import App from './App.vue';
import store from './store/Index';
import router from './router/Index';
// 清除默认样式
import './assets/css/reset.css'
import './assets/css/refesh.scss'
import ElementPlus from 'element-plus'
import ElementUI from 'element-plus/es/index'
import 'element-plus/dist/index.css'

//图片懒加载
import imgLazy from '@/utils/lazyload'
// 节流
import preventReClick from '@/utils/preventClick'
import trim from '@/utils/trim'
// 判断是登录状态
import isLoginClickCheck from '@/utils/isLogin'
// 图片添加水印
import watermark from '@/utils/wateMark'
// 传值
import mitt from 'mitt'
import localStorageUtils from '@/utils/localstorage'

//全局监听点击事件
import globalClickHandler from '@/assets/js/globalClickHandler.js'

import XEUtils from 'xe-utils'
// import VXETable from 'vxe-table'
import './assets/css/vxetable.scss'

//生成随机字符串
import { randomString } from "@/utils/common";

// import {
//   // 全局对象
//   VXETable,
//   Edit,
//   Validator,
//   Icon,
//   Column,
//   // 表格
//   Table,
//   Modal,
//   Grid,

// } from 'vxe-table'
// import zhCN from 'vxe-table/es/locale/lang/zh-CN'
import VXETablePluginElement from 'vxe-table-plugin-element'
import 'vxe-table-plugin-element/dist/style.css'


// // 按需加载的方式默认是不带国际化的，自定义国际化需要自行解析占位符 '{0}'，例如：
// VXETable.setup({
//   i18n: (key, args) => XEUtils.toFormatString(XEUtils.get(zhCN, key), args)
// })

import VxeTable from 'vxe-table'
import 'vxe-table/lib/style.css'

import VxeUI from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'
VxeTable.use(VXETablePluginElement);


// 挂在防止多个弹框
import { message } from '@/utils/resetMessage'

// 引入骨架屏组件
import Skeletion from '@x-ui-vue3/skeleton'

import * as buffer from "buffer"; //引入buffer
if (typeof (window as any).Buffer === "undefined") { // 判断当前环境是否有Buffer对象
  (window as any).Buffer = buffer.Buffer; // Buffer对象不存在则创建导入的buffer
}

// 创建vue实例
const app = createApp(App);
// function useTable (app) {
//   // 可选组件
//   app.use(Icon)
//   .use(Edit)
//   .use(Column)
//   .use(Validator)
//   .use(Table)
//   .use(Modal)
//   .use(Grid)
// }
app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(ElementUI);
// app.use(useTable)
app.use(VxeUI)
app.use(VxeTable)
app.use(imgLazy);
app.use(preventReClick);
app.use(trim)
app.use(isLoginClickCheck);
app.use(watermark)
app.use(Skeletion)
app.config.globalProperties.$mitt = mitt()
app.config.globalProperties.$msg = message
app.config.globalProperties.localStorageUtils = localStorageUtils
// 挂载实例
router.isReady().then(() => {
  app.mount('#app')
})

// await fetch('https://dev-api.gansuan.com/statistic/center/api/clk/uuid.png', {
//         method: 'get'
//       });



// 配置防抖延迟和状态锁
const CLICK_DELAY = 0;
let isProcessing = false;

// 增强版防抖函数（支持异步隔离）
function asyncDebounce(fn, delay) {
  let timer = null;
  return async function(...args) {
    if (isProcessing) return;
    clearTimeout(timer);
    return new Promise(resolve => {
      timer = setTimeout(async () => {
        isProcessing = true;
        try {
          resolve(await fn.apply(this, args));
        } finally {
          isProcessing = false;
        }
      }, delay);
    });
  };
}

// 全局点击处理器
const globalClickHandler = asyncDebounce(async (event) => {
  await fetch( import.meta.env.VITE_SECOND_BASE_API + '/statistic/center/api/clk/'+ randomString(10) + '.png', {
    method: 'get'
});
}, CLICK_DELAY);

// 初始化函数
function initClickHandler() {
  document.removeEventListener('click', globalClickHandler);
  document.addEventListener('click', globalClickHandler, true);
}

// 页面加载初始化
if (document.readyState === 'complete') {
  initClickHandler();
} else {
  window.addEventListener('DOMContentLoaded', initClickHandler);
}

